(function() {
  document.querySelectorAll(".vplayer").forEach(vplayer => {
    let videoID = vplayer.dataset.v;
    
    if (!videoID) {
      console.error("Missing video ID for", vplayer);
      return;
    }

    console.log("Video ID:", videoID);
    let thumbnailSrc = "https://img.youtube.com/vi/" + videoID + "/sddefault.jpg";

    let image = new Image();
    image.src = thumbnailSrc;
    image.classList.add('lazyload');
    image.setAttribute("alt", "youtube-video");

    image.onload = function() {
      vplayer.appendChild(image);
    };

    vplayer.addEventListener("click", function() {
      let iframe = document.createElement("iframe");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("autoplay", "1");
      iframe.setAttribute("muted", "1");
      iframe.setAttribute("playsinline", "");
      iframe.setAttribute("src", "https://www.youtube.com/embed/" + videoID + "?autoplay=1&mute=1&enablejsapi=1");

      this.innerHTML = "";
      this.appendChild(iframe);
    });
  });
})();



    var swiper = new Swiper(".mySwiper", {
      
  slidesPerView: 1,
  grabCursor: true,
  freeMode: false,
  loop: true,
  mousewheel: false,
  keyboard: {
    enabled: true
  },

 

  // If we need navigation
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },

  // Responsive breakpoints
  breakpoints: {
    375:{
      slidesPerView: 1.50,
      spaceBetween: 20
    },
    425:{
      slidesPerView: 1.30,
      spaceBetween: 20
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
    });
